export const thetype = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  GET_ERRORS: 'GET_ERRORS'
}